import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, MessageSquare } from 'lucide-react';
export function FinalCTA() {
  return <section id="contact" className="py-16 sm:py-20 md:py-24 lg:py-32 bg-white" data-id="element-331">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8" data-id="element-332">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative overflow-hidden rounded-[2rem] sm:rounded-[2.5rem] md:rounded-[3rem] bg-gradient-to-br from-blue-600 to-indigo-700 px-6 py-16 sm:px-8 sm:py-20 md:px-12 md:py-24 text-center shadow-2xl shadow-blue-900/20" data-id="element-333">
          {/* Decorative circles */}
          <div className="absolute -top-24 -left-24 h-64 w-64 rounded-full bg-white/10 blur-3xl" data-id="element-334" />
          <div className="absolute -bottom-24 -right-24 h-64 w-64 rounded-full bg-blue-400/20 blur-3xl" data-id="element-335" />

          <div className="relative z-10" data-id="element-336">
            <h2 className="mb-6 sm:mb-8 text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-white" data-id="element-337">
              ¿Listo para construir?
            </h2>
            <p className="mx-auto mb-8 sm:mb-10 md:mb-12 max-w-2xl text-base sm:text-lg md:text-xl text-blue-100" data-id="element-338">
              Conversemos sobre cómo podemos materializar tu visión con los más
              altos estándares de calidad y diseño.
            </p>

            <div className="flex flex-col items-center justify-center gap-4 sm:flex-row" data-id="element-339">
              <motion.a href="mailto:contacto@forax.cl" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full bg-white px-8 sm:px-10 py-4 sm:py-5 text-base sm:text-lg font-bold text-blue-600 shadow-xl transition-colors hover:bg-gray-50" data-id="element-340">
                Contactar a Forax
                <ArrowRight className="h-5 w-5" data-id="element-341" />
              </motion.a>

              <motion.a href="#" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full border-2 border-white/30 bg-transparent px-8 sm:px-10 py-4 sm:py-5 text-base sm:text-lg font-bold text-white transition-colors hover:bg-white/10" data-id="element-342">
                <MessageSquare className="h-5 w-5" data-id="element-343" />
                Agendar reunión
              </motion.a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}